<template>
  <b-modal
    hide-footer
    id="modal-gcc"
    ref="modal-gcc"
    size="lg"
    title="รายละเอียด"
  >
    <b-row>
      <b-col cols="12">
        <GccDetail :gccObj="gccObj"></GccDetail>
      </b-col>
    </b-row>
    <!-- <footer id="modal-gcc___BV_modal_footer_" class="modal-footer">
      <button type="button" class="btn btn-primary" block @click="onSubmit">บันทึก</button>
    </footer> -->
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BModal,
  BForm,
  BButton,
  BFormTextarea,
} from "bootstrap-vue";
import GccDetail from "@/views/Complaint/GCC/components/GCCDetail.vue";
import CompanyAddress from "./CompanyAddress.vue";

import { VueAutosuggest } from "vue-autosuggest";
import * as companyStore from "@/store/api/company/index.js";

import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    vSelect,
    VueAutosuggest,
    CompanyAddress,
    GccDetail,
  },
  props: {
    gccObj: {
      rootobject: {},
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style></style>
